import type { ThemeConfig } from 'antd';

/** Button-only tokens: inputs, selects, and the app's 12px rem scale stay independent. */
export const dashboardButtonTheme: NonNullable<ThemeConfig['components']>['Button'] = {
  controlHeight: 40,
  controlHeightSM: 32,
  controlHeightLG: 48,
  borderRadius: 6,
  borderRadiusSM: 6,
  borderRadiusLG: 6,
  fontFamily: 'Averta, sans-serif',
  fontWeight: 500,
  contentFontSize: 14,
  contentFontSizeSM: 13,
  contentFontSizeLG: 14,
  contentLineHeight: 20 / 14,
  contentLineHeightSM: 18 / 13,
  contentLineHeightLG: 20 / 14,
  paddingInline: 16,
  paddingInlineSM: 12,
  paddingInlineLG: 20,
  iconGap: 8,
  onlyIconSize: 16,
  onlyIconSizeSM: 16,
  onlyIconSizeLG: 16,
  colorPrimary: '#083147',
  colorPrimaryHover: '#0c496a',
  colorPrimaryActive: '#083047',
  primaryColor: '#fff',
  defaultColor: '#083147',
  defaultBg: '#fff',
  defaultBorderColor: '#083147',
  defaultHoverColor: '#083147',
  defaultHoverBorderColor: '#083147',
  defaultHoverBg: '#f0f3f8',
  defaultActiveColor: '#083147',
  defaultActiveBorderColor: '#083147',
  defaultActiveBg: '#e5eaf0',
  textTextColor: '#083147',
  textTextHoverColor: '#083147',
  textTextActiveColor: '#083147',
  textHoverBg: '#f0f3f8',
  colorLink: '#083147',
  colorLinkHover: '#0c496a',
  colorLinkActive: '#083047',
  linkHoverBg: '#f0f3f8',
  colorBgContainerDisabled: '#f3f3f3',
  colorTextDisabled: '#999',
  borderColorDisabled: '#dbdbdb',
  defaultShadow: 'none',
  primaryShadow: 'none',
  dangerShadow: 'none',
  motionDurationMid: '0.14s',
  motionDurationSlow: '0.14s'
};
